export default () => (
  new Promise<boolean>((resolve) => {
    const ad = document.createElement('div');
    ad.innerHTML = '&nbsp;';
    ad.className = 'adsbox';
    document.body.appendChild(ad);

    window.setTimeout(() => {
      if (ad.offsetHeight === 0) {
        resolve(true);
        return;
      }

      document.body.removeChild(ad);

      resolve(false);
    }, 100);
  })
);
